export class RequestArrayModel<T> {
  public body: T[] = [];

  constructor(data: T[]) {
    this.body = data;
  }
}
